var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { attrs: { id: "embed-header", role: "banner" } }, [
    _c(
      "div",
      { staticClass: "embed-header__date-section" },
      [
        _c("AppNavigationHeaderDatePicker"),
        _vm._v(" "),
        _c("AppNavigationHeaderTodayButton")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "embed-header__views-section" },
      [_c("AppNavigationHeaderViewButtons")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "embed-header__share-section" },
      [
        _c(
          "Actions",
          { attrs: { "default-icon": "icon-download" } },
          _vm._l(_vm.subscriptions, function(calendar) {
            return _c(
              "ActionLink",
              {
                key: calendar.id,
                attrs: {
                  icon: "icon-download",
                  target: "_blank",
                  href: calendar.url + "?export"
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t("calendar", "Download {name}", {
                        name:
                          calendar.displayName ||
                          _vm.$t("calendar", "Untitled calendar")
                      })
                    ) +
                    "\n\t\t\t"
                )
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "Actions",
          { attrs: { "default-icon": "icon-calendar-dark" } },
          _vm._l(_vm.subscriptions, function(calendar) {
            return _c(
              "ActionButton",
              {
                key: calendar.id,
                attrs: { icon: "icon-calendar-dark" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.copySubscriptionLink(calendar)
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t("calendar", "Subscribe to {name}", {
                        name:
                          calendar.displayName ||
                          _vm.$t("calendar", "Untitled calendar")
                      })
                    ) +
                    "\n\t\t\t"
                )
              ]
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }